import { Outlet } from 'react-router-dom';

// project imports

// ==============================|| MINIMAL LAYOUT ||============================== //

export const MinimalLayout: React.FC = () => (
  <>
    <Outlet />
  </>
);
